export enum FormatType {
  Physical = 'Physical',
  Merchandise = 'Merchandise',
}
